var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreatorTargeting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.875C10.8117 11.875 11.875 10.8117 11.875 9.5C11.875 8.18832 10.8117 7.125 9.5 7.125C8.18832 7.125 7.125 8.18832 7.125 9.5C7.125 10.8117 8.18832 11.875 9.5 11.875Z",
    fill: "#1C1E21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2913 3.21999V1.58203H8.70801V3.21999C7.31481 3.3976 6.02003 4.03282 5.02691 5.02594C4.0338 6.01905 3.39858 7.31383 3.22097 8.70703H1.58301V10.2904H3.22097C3.39845 11.6836 4.03363 12.9785 5.02677 13.9716C6.0199 14.9647 7.31476 15.5999 8.70801 15.7774V17.4154H10.2913V15.7774C11.6846 15.5999 12.9794 14.9647 13.9726 13.9716C14.9657 12.9785 15.6009 11.6836 15.7784 10.2904H17.4163V8.70703H15.7784C15.6008 7.31383 14.9656 6.01905 13.9724 5.02594C12.9793 4.03282 11.6845 3.3976 10.2913 3.21999ZM9.49968 14.2487C6.88005 14.2487 4.74967 12.1183 4.74967 9.4987C4.74967 6.87907 6.88005 4.7487 9.49968 4.7487C12.1193 4.7487 14.2497 6.87907 14.2497 9.4987C14.2497 12.1183 12.1193 14.2487 9.49968 14.2487Z",
    fill: "#1C1E21"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorTargeting);
export default __webpack_public_path__ + "static/media/creatorTargeting.b9e5cdd9.svg";
export { ForwardRef as ReactComponent };